import Vue from 'vue';
import VueRouter, { Route, NavigationGuardNext, RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import Register from '../views/Register.vue';
import List from '../views/List.vue';
import Users from '../views/Users.vue';
import store from '../store';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    props: true
  },
  {
    path: '/users',
    name: 'users',
    component: Users,
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
      if (store.state.authenticationModule.localUser) {
        next();
      } else {
        next('/register');
      }
    }
  },
  {
    path: '/list/:userID',
    name: 'list',
    component: List,
    beforeEnter: (to: Route, from: Route, next: NavigationGuardNext): void => {
      if (store.state.authenticationModule.localUser) {
        next();
      } else {
        next('/register');
      }
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
